import axios from 'axios'
import * as Config from '../../config'

const state = {}

const actions = {

  load_Supports({commit, dispatch}) {
    return new Promise((resolve, reject) => {

      axios.get(Config.apiPath + 'support/list/all')
        .then(
          response => {
            resolve(response.data);

          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  load_Support({commit, dispatch}, form) {
    return new Promise((resolve, reject) => {
      axios.get(Config.apiPath + 'support/consult/' + form.id)
        .then(
          response => {
            resolve(response.data);

          })
        .catch(error => {
          reject(error.response.data);
        });
    });

  },
  new_Support({commit, dispatch}, form) {

    return new Promise((resolve, reject) => {
      axios.post(Config.apiPath + 'support/store', form)
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  changeActive_Support({commit, dispatch}, form) {

    return new Promise((resolve, reject) => {
      axios.put(Config.apiPath + 'support/change/active/' + form.id + '/' + form.active)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  changeStatus_Support({commit, dispatch}, form) {

    return new Promise((resolve, reject) => {
      axios.put(Config.apiPath + 'support/change/status/' + form.id + '/' + form.status)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error.response.data);
        });
    });
  },
  update_Support({commit, dispatch}, form) {

    return new Promise((resolve, reject) => {
      axios.put(Config.apiPath + 'support/update/' + form.id, form)
        .then(
          response => {
            resolve(response.data);
          })
        .catch(error => {
          reject(error.response.data);
        });
    });
  }

}

const mutations = {}

export default {
  state,
  actions,
  mutations
}
